import React from 'react';
import { Modal, Spinner } from 'react-bootstrap';

import { useTranslation } from '../../hooks/useTranslation';

export interface InProgressModalProps {
  message?: string;
}

export const WaitingModal: React.FC<InProgressModalProps> = props => {
  const { t, tk } = useTranslation('commonLng');
  return (
    <Modal
      show={true}
      backdrop="static"
      keyboard={false}
      centered
      contentClassName="p-4 rounded-4"
    >
      <Modal.Body className="text-center">
        <div>
          <Spinner animation="grow" variant="info" className="m-1" />
          <Spinner animation="grow" variant="warning" className="m-1" />
          <Spinner animation="grow" variant="info" className="m-1" />
        </div>
        <h4 className="mb-3">{t(tk.component.pleaseWait)}</h4>
        <p className="text-muted mb-0">{props.message ?? ''}</p>
      </Modal.Body>
    </Modal>
  );
};
